import { BoardHeader } from './BoardHeader'
import './styles.modules.scss'

export default BoardHeader
